export function setCanonicalLink(doc: Document, href: string): void {
  let link = doc.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
  if (!link) {
    link = doc.createElement("link");
    link.setAttribute("rel", "canonical");
    doc.head.appendChild(link);
  }
  link.setAttribute("href", href);
}
